'use client';

import clsx from 'clsx';
import type { ReactNode } from 'react';

export function Field({
  className,
  children,
  label,
  description,
  ...props
}: {
  className?: string;
  children: ReactNode;
  label?: ReactNode;
  description?: ReactNode;
} & React.ComponentPropsWithoutRef<'div'>) {
  return (
    <div className={clsx(className, 'space-y-2')} {...props}>
      {label && (
        <label className="block text-sm font-medium text-zinc-950 dark:text-white">
          {label}
        </label>
      )}
      {children}
      {description && (
        <p className="text-sm text-zinc-500 dark:text-zinc-400">
          {description}
        </p>
      )}
    </div>
  );
}
